import { render, staticRenderFns } from "./RequestInventory.vue?vue&type=template&id=77389ead&lang=pug&"
import script from "./RequestInventory.vue?vue&type=script&lang=js&"
export * from "./RequestInventory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports